export const Laugh = ({ ...props }) => {
  return (
    <svg
      version="1.1"
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 512.001 512.001"
      {...props}
    >
      <title>Laugh</title>
      <circle
        style={{ fill: '#F7B239' }}
        cx="256.005"
        cy="256.004"
        r="246.855"
      />
      <path
        style={{ fill: '#E09B2D' }}
        d="M126.308,385.694c-88.802-88.802-95.799-228.426-20.999-325.241
      c-8.286,6.401-16.258,13.399-23.858,20.999c-96.401,96.401-96.401,252.698,0,349.099s252.698,96.401,349.099,0
      c7.599-7.599,14.597-15.573,20.999-23.858C354.735,481.492,215.109,474.495,126.308,385.694z"
      />
      <path
        style={{ fill: '#FFFFFF' }}
        d="M131.567,264.613h248.868c0,13.968-2.306,27.4-6.551,39.941H138.118
      C133.873,292.013,131.567,278.582,131.567,264.613z"
      />
      <path
        style={{ fill: '#A81004' }}
        d="M138.118,304.554h235.765c-8.369,24.716-24.289,45.931-45.016,60.924
      c-8.71-14.676-24.716-24.509-43.027-24.509c-11.187,0-21.508,3.672-29.84,9.882c-8.332-6.21-18.665-9.882-29.852-9.882
      c-18.299,0-34.317,9.833-43.015,24.509C162.407,350.485,146.487,329.27,138.118,304.554z"
      />
      <path
        style={{ fill: '#F95428' }}
        d="M285.841,340.969c18.311,0,34.317,9.833,43.027,24.509c-20.483,14.834-45.662,23.569-72.867,23.569
      s-52.384-8.735-72.867-23.569c8.698-14.676,24.716-24.509,43.015-24.509c11.187,0,21.52,3.672,29.852,9.882
      C264.333,344.641,274.654,340.969,285.841,340.969z"
      />
      <path
        d="M256.001,0C114.842,0,0.001,114.841,0.001,256.001s114.841,256.001,256.001,256.001
      c141.158,0,255.999-114.841,255.999-256.001S397.159,0,256.001,0z M256.001,493.701c-131.069,0-237.702-106.631-237.702-237.7
      S124.932,18.299,256.001,18.299c131.068,0,237.7,106.632,237.7,237.702S387.069,493.701,256.001,493.701z"
      />
      <path
        d="M380.435,255.464H131.567c-5.053,0-9.15,4.097-9.15,9.15c0,14.662,2.367,29.087,7.034,42.876
      c8.934,26.382,25.643,48.999,48.314,65.4c22.86,16.557,49.914,25.309,78.235,25.309c28.32,0,55.373-8.752,78.23-25.305
      c22.676-16.405,39.386-39.02,48.319-65.402l0,0c4.667-13.789,7.034-28.214,7.034-42.875
      C389.585,259.56,385.488,255.464,380.435,255.464z M370.927,273.763c-0.576,7.338-1.854,14.575-3.809,21.642H144.883
      c-1.954-7.067-3.233-14.303-3.809-21.642H370.927z M196.223,363.202c7.649-8.21,18.499-13.083,29.926-13.083
      c8.87,0,17.302,2.79,24.385,8.067c3.244,2.417,7.691,2.417,10.934,0c7.082-5.279,15.509-8.067,24.372-8.067
      c11.421,0,22.272,4.871,29.932,13.085c-17.972,10.947-38.452,16.692-59.772,16.692C234.68,379.898,214.198,374.151,196.223,363.202z
       M330.677,352.44c-11.137-12.9-27.533-20.621-44.838-20.621c-10.623,0-20.819,2.77-29.84,8.066
      c-9.021-5.295-19.221-8.066-29.852-8.066c-17.311,0-33.707,7.722-44.829,20.617c-12.623-10.71-22.68-23.855-29.665-38.733h208.694
      C353.362,328.583,343.304,341.728,330.677,352.44z"
      />
      <path
        d="M206.973,209.881c0.827-3.622-0.617-7.386-3.657-9.523l-54.287-38.174c-4.133-2.906-9.84-1.913-12.747,2.221
      c-2.906,4.133-1.912,9.84,2.222,12.747l35.988,25.306l-75.523,12.47c-4.986,0.823-8.36,5.532-7.537,10.518
      c0.739,4.481,4.619,7.66,9.017,7.66c0.495,0,0.997-0.04,1.502-0.123l97.595-16.113C203.21,216.265,206.146,213.503,206.973,209.881z
      "
      />
      <path
        d="M413.034,214.929L337.51,202.46l35.988-25.306c4.133-2.907,5.129-8.614,2.222-12.747c-2.907-4.134-8.615-5.129-12.747-2.222
      l-54.287,38.174c-3.039,2.137-4.484,5.9-3.657,9.523c0.827,3.623,3.764,6.384,7.429,6.989l97.595,16.113
      c0.505,0.083,1.006,0.123,1.502,0.123c4.397,0,8.276-3.179,9.017-7.66C421.395,220.461,418.02,215.752,413.034,214.929z"
      />
    </svg>
  );
};
